// extracted by mini-css-extract-plugin
module.exports = {"container":"searchpage_container__3pY-y","results":"searchpage_results__1yrT6","message":"searchpage_message__3UnUn"};